import React, { useState } from 'react';
import { LineOpacity, Checkbox } from '../shape.map';
import type { ShowOpacityOption } from '@/types/properties';
import styles from '../../../styles/global.module.css';
import type { DynamicComponentProps } from '@/types/commontypes';

const ShowOpacityOptionComponent: React.FC<DynamicComponentProps<ShowOpacityOption>> = ({ label, value, onChange }) => {
  const [isSliderEnabled, setSliderEnabled] = useState(true);

  const handleVisibilityChange = (checked: boolean) => {
    setSliderEnabled(checked);
    onChange({ ...value, show: checked });
  };

  const handleOpacityChange = (opacity: number) => {
    onChange({ ...value, opacity });
  };

  return (
    <div className={styles.property_row}>
      <label className={styles.property_label}>{label}</label>
      <div className={styles.property_value}>
        <Checkbox value={value.show} onChange={handleVisibilityChange} label="" />
        <LineOpacity value={value.opacity} onChange={handleOpacityChange} label="" disabled={!isSliderEnabled} />
      </div>
    </div>
  );
};

export default ShowOpacityOptionComponent;
